type Props = { status: string; className?: string };

const STATUS_COLORS: Record<string, string> = {
  UNASSIGNED: 'bg-[var(--status-muted-bg)] text-[var(--status-muted-fg)]',
  ALLOCATED:  'bg-[var(--status-info-bg)] text-[var(--status-info-fg)]',
  DISPATCHED: 'bg-[var(--status-info-bg)] text-[var(--status-info-fg)]',
  RELEASED:   'bg-[var(--status-success-bg)] text-[var(--status-success-fg)]',
  ONGOING:    'bg-[var(--status-warning-bg)] text-[var(--status-warning-fg)]',
  COMPLETED:  'bg-[var(--status-success-bg)] text-[var(--status-success-fg)]',
  BILLING_PENDING: 'bg-[var(--status-success-bg)] text-[var(--status-success-fg)]',
  BILLED:     'bg-[var(--status-success-bg)] text-[var(--status-success-fg)]',
  CANCELLED:  'bg-[var(--status-danger-bg)] text-[var(--status-danger-fg)]',
};

// Driver-facing labels. ALLOCATED is the ops action (car+driver set on the
// booking); DISPATCHED is the downstream state (trip is live, driver heading
// to pickup, pre-start). The two are intentionally distinct. Title Case (no
// CSS uppercase) keeps the pills readable and less shouty than the operator
// app's all-caps treatment.
//
// BILLING_PENDING + BILLED collapse to "Completed" for the driver — they're
// ops bookkeeping the driver doesn't need to track.
const DRIVER_LABELS: Record<string, string> = {
  UNASSIGNED: 'Unassigned',
  ALLOCATED:  'Allocated',
  DISPATCHED: 'Dispatched',
  RELEASED:   'Released',
  ONGOING:    'Ongoing',
  COMPLETED:  'Completed',
  BILLING_PENDING: 'Completed',
  BILLED:     'Completed',
  CANCELLED:  'Cancelled',
};

export function StatusBadge({ status, className = '' }: Props) {
  const key = (status || '').toUpperCase();
  const colors = STATUS_COLORS[key] || STATUS_COLORS.UNASSIGNED;
  const fallback = status
    ? status.charAt(0).toUpperCase() + status.slice(1).toLowerCase().replace(/_/g, ' ')
    : '';
  const label = DRIVER_LABELS[key] || fallback;
  return (
    <span className={`inline-block px-3 py-1 rounded-full text-xs font-semibold tracking-wider ${colors} ${className}`}>
      {label}
    </span>
  );
}
